<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRetirar="opcionRetirar" :opcionGestionar="opcionGestionar"  :requiereGestionar="requiereGestionar"
         :titulomodal="titulomodal" :botonmodal="botonmodal" :requiereBotongestionar="requiereBotongestionar" 
         :condicionales="condicionales" :carpeta="carpeta" :datosExcel="datosExcel" :typeOrder="typeOrder"
         :opcionRetiroProveedor="opcionRetiroProveedor"></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            datosExcel:[],
            nombreEntidad: "entidad_solicitud",
            idVersion: 2,
            column: "id",
            typeOrder: "desc",
            perPage: 100,
            currentPage: 1,
             vista:"Solicitudes de retiro",
             proveniente:"- Solicitudes de retiro",
             carpeta:"Proveedores",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"Retirado",
             editable:1,
             cliente:1,
             requiereGestionar:false,
             opcionRetirar:false,
             opcionGestionar:false,
             opcionRetiroProveedor:true,
             titulomodal:"Seguimiento",
             botonmodal:"Aceptar",
             requiereBotongestionar:"si",
             options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' }, { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'departamento', text: 'Departamento' }],
             
             departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsclientes: [
                { value: null, text: 'Seleccionar' },
                { value: 1, text: 'cliente1' },
                { value: 2, text: 'clientes2' }
            ],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            optionss: [
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                 { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '9', text: 'Solicitud retiro' },
                { value: '14', text: 'En proceso de retiro' },
                { value: '15', text: 'Retiro fallido' },
                { value: '13', text: 'Retirado' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },

            ],
            optionm:[{ value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },
             ],
            endDate: "",
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Solicitante', sortable: true }, 
                { key: 'F.Solicitud', sortable: true }, 
                { key: 'Asignó', sortable: true }, 
                { key: 'F.Asignación', sortable: true }, 
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                 { key: 'Paciente', sortable: true },
                 {key: 'Ciudad', sortable: true },
                 { key: 'Departamento', sortable: true },
                  { key: 'Estado', sortable: true },  'Acciones'],
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            condicionales: null,
            relaciones: [
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "tipo_documento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "Tipos_documento"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "medio_administracion",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "motivos_rechazo_proveedor"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "codigo_departamento" },
                        "columna_relacion_principal": "departamento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "divipola_colombia"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "estado",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "estados"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_proveedor",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_proveedor",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_cliente",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_cliente",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_prestador",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_prestador",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            ],
         }
 
     },
     computed: {
       
     },
     async created() {
        try {
            const datosUser = localStorage.getItem('user');
            let datoUserJSON = JSON.parse(datosUser);
            let dato_proveedor = datoUserJSON.id_proveedor;
            console.log('🔍 dato_proveedor:', dato_proveedor);
            if (dato_proveedor == null) {
                this.condicionales = {
                    "OR": [
                        {
                            "estado": {
                                "iLike": "9"
                            }
                        },
                        {
                            "estado": {
                                "iLike": "14"
                            }
                        },
                        {
                            "estado": {
                                "iLike": "15"
                            }
                        }
                    ]
                };
            } else {
                this.condicionales = {
                    "OR": [
                        {
                            "AND": [
                                {
                                    "estado": {
                                        "iLike": "9"
                                    }
                                },
                                {
                                    "id_proveedor": {
                                        "equals": dato_proveedor
                                    }
                                }
                            ]
                        },
                        {
                            "AND": [
                                {
                                    "estado": {
                                        "iLike": "14"
                                    }
                                },
                                {
                                    "id_proveedor": {
                                        "equals": dato_proveedor
                                    }
                                }
                            ]
                        },
                        {
                            "AND": [
                                {
                                    "estado": {
                                        "iLike": "15"
                                    }
                                },
                                {
                                    "id_proveedor": {
                                        "equals": dato_proveedor
                                    }
                                }
                            ]
                        }
                    ]
                };
            }
            console.log('🔍 condicionales:', JSON.stringify(this.condicionales, null, 2));
            var where = [this.condicionales];
            var params = {
                        "nombreEntidad": this.nombreEntidad,
                        "idVersion": this.idVersion,
                        "column": this.column,
                        "type": this.typeOrder,
                        "size": this.perPage,
                        "page": this.currentPage,
                    }
                    const response = await config.getMetaData(params, where, this.relaciones);
                    
                    this.totalfilas = response.message.count
                    this.items = [];
                    var cantidad = this.perPage;
                   
                    if(response.message =='Error no se encontró datos'){
                        this.totalfilas=0;
                    }

                    var dataexcel=[]
                    for (var i = 0; i < cantidad; i++) {
                        var estadosE = response.message.rows;
                        var numeracion = ((this.currentPage - 1) * cantidad) + i;
                        var dataTable = estadosE[i]['data'];


                        
                        const objetoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.tipo_documento && item.nombre_lista === "Tipos_documento");
                        const nameResultado = objetoBuscado ? objetoBuscado.row_data.name : null;
                        const estadobuscando = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.estado && item.nombre_lista === "estados");
                        const estadoresultado = estadobuscando ? estadobuscando.row_data.name : null;

                       
                        const nombreCliente = dataTable.entidad_cliente[0][0]?.data?.nombre_cliente || "";
                        const nombreProveedor = dataTable.entidad_proveedor[0][0]?.data?.nombre_proveedor || "";
                        const nombrePrestador = dataTable.entidad_prestador[0][0]?.data?.nombre_prestador || "";
                        const departamentobuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.codigo_departamento === dataTable.departamento && item.nombre_lista === "divipola_colombia");
                        const departamentoResultado = departamentobuscado ? departamentobuscado.row_data.nombre_departamento : null;
                        const municipioResultado = departamentobuscado ? departamentobuscado.row_data.nombre_municipio : null;
                      
                        this.datosExcel[numeracion] = {
                            'N°Solicitud': dataTable.id,
                            'Solicitante': nombreCliente,
                            'F.Solicitud': dataTable.createat.slice(0, 10),
                            'Asignó': nombrePrestador,
                            'F.Asignación': dataTable.fecha_asignacion ? this.formatearFechaConOffset(dataTable.fecha_asignacion,-5) : '',
                            'T.Documento': nameResultado,
                            "Documento": dataTable.documento,
                            "Paciente": dataTable.nombre_completo,
                            'Ciudad': municipioResultado,
                            'Departamento': departamentoResultado,
                            "Estado":estadoresultado,
                        };
                    }  
            } catch (error) {
                console.log(error)
            }
 
     },
     
     methods: {
      // Función para formatear fecha con offset personalizado y formato AM/PM
        // Uso: this.formatearFechaConOffset(fecha, -5)  para Colombia
        //      this.formatearFechaConOffset(fecha, -10) para otros casos
        formatearFechaConOffset(fechaString, offsetHoras) {
        const fechaUTC = new Date(fechaString);
        const fechaAjustada = new Date(fechaUTC.getTime() + (offsetHoras * 60 * 60 * 1000));
        const año = fechaAjustada.getUTCFullYear();
        const mes = this.agregarCero(fechaAjustada.getUTCMonth() + 1);
        const dia = this.agregarCero(fechaAjustada.getUTCDate());
        let horas24 = fechaAjustada.getUTCHours();
        const minuto = this.agregarCero(fechaAjustada.getUTCMinutes());
        const ampm = horas24 >= 12 ? 'PM' : 'AM';
        let horas12 = horas24 % 12;
        horas12 = horas12 === 0 ? 12 : horas12;
        const horaFormateada = this.agregarCero(horas12);
        return `${año}-${mes}-${dia} ${horaFormateada}:${minuto} ${ampm}`;
        },
     }
 };
 </script>
 <style>
 </style>
